import React from "react";
import PrimaryHeading from '../../../components/common/primaryHeading';
import ButtonWithSearch from '../../../components/common/buttonWithSearch';
import InputPrimaryComponents from '../../../components/common/inputPrimaryComponents';
import AddButtonSection from '../../../components/common/AddButtonSection';
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";

const ViewNotification = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const notification = location?.state?.notification || {};

    const toJoined = (arr, keyCandidates = []) => {
        if (!Array.isArray(arr)) return arr || "";
        const names = arr
            .map((item) => {
                if (typeof item === "string") return item;
                for (const k of keyCandidates) {
                    if (item?.[k]) return item[k];
                }
                return "";
            })
            .filter(Boolean);
        return names.join(", ");
    };

    const usersJoined = toJoined(notification?.notification_users, ["user_name", "name"]);
    const campsJoined = toJoined(notification?.notification_camps, ["camp_name", "name"]);

    console.log(notification);
    
    const { control } = useForm({
        defaultValues: {
            sno: notification?.serial_number || "",
            title: notification?.notification_title || "",
            description: notification?.notification_description || "",
            schedule_time: notification?.schedule_time || "",
            users: usersJoined,
            camps: campsJoined,
            scheduler: notification?.scheduler_type || "",
        }
    });

    const viewButtons = [
        {
            type: "primarySuccessButton",
            label: "Cancel",
            class: "pl-3",
            onClick: () => {
                navigate('/notifications/history');
            },
        },
    ];

    return (
        <div className="container  md:mt-3 mb-3">
            <PrimaryHeading className={"mt-5 mb-3"} />
            <div style={{ color: "rgba(47, 43, 61, 0.9)" }}>
                <ButtonWithSearch
                    searchHeaderLable={"Schedule Maintenace"}
                />
            </div>
            <form className="mt-4">
                <div className="row md:flex gap-1rem">
                    <div className="col" style={{ flex: 1 }}>

                        <div>
                            <InputPrimaryComponents
                                control={control}
                                type="text"
                                name="sno"
                                label="S No"
                                disabled
                            />
                        </div>
                        <div className=" md:mt-3">
                            <InputPrimaryComponents
                                control={control}
                                type="text"
                                name="title"
                                label="Title"
                                disabled
                            />
                        </div>
                        <div className=" md:mt-3">
                            <InputPrimaryComponents
                                control={control}
                                type="text"
                                name="description"
                                label="Description"
                                disabled
                            />
                        </div>
                        <div className=" md:mt-3">
                            <InputPrimaryComponents
                                control={control}
                                type="text"
                                name="schedule_time"
                                label="Schedule Time"
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col">
                        <div className="">
                            <InputPrimaryComponents
                                control={control}
                                type="text"
                                name="users"
                                label="Users"
                                disabled
                            />
                        </div>
                        <div className=" md:mt-3">
                            <InputPrimaryComponents
                                control={control}
                                type="text"
                                name="camps"
                                label="Camps"
                                disabled
                            />
                        </div>
                        <div className=" md:mt-3">
                            <InputPrimaryComponents
                                control={control}
                                type="text"
                                name="scheduler"
                                label="Scheduler"
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </form>
            <div className="mt-2">
                <AddButtonSection buttons={viewButtons} />
            </div>
        </div>
    );
};

export default ViewNotification; 